import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
export interface HistorialSoat {
  id?: number;
  placa: string;
  id_soat: number;
  fecha_soat: string;
  vencimiento_soat: string;
  aseguradora: string;
  valor: number;
  tarifa: number;
  estado: number;
}

@Injectable({
  providedIn: 'root',
})
export class HistorialSoatService {
  private apiUrl =  `${environment.apiUrl}/api/historial`; 
//  private apiUrl = 'http://localhost:3000/api/historial';

  constructor(private http: HttpClient) {}

  // Método para obtener headers básicos (sin autenticación por token)
  private getAuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // 🔹 Obtener todos los SOAT
  getAll(): Observable<{ historial: HistorialSoat[], estadisticas: any }> {
    return this.http.get<{ historial: HistorialSoat[], estadisticas: any }>(this.apiUrl, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error("❌ Error al obtener los SOAT:", error);
        return throwError(() => new Error("Error al obtener los SOAT"));
      })
    );
  }

  getById(id: number): Observable<HistorialSoat> {
    return this.http.get<HistorialSoat>(`${this.apiUrl}/${id}`, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al obtener el SOAT:', error);
        return throwError(() => new Error('Error al obtener el SOAT'));
      })
    );
  }
  
  

  // 🔹 Obtener SOAT por Placa
  getByPlaca(placa: string): Observable<HistorialSoat[]> {
    return this.http.get<HistorialSoat[]>(`${this.apiUrl}/placa/${placa}`, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al obtener SOAT por placa:', error);
        return throwError(() => new Error('Error al obtener SOAT por placa'));
      })
    );
  }

  // 🔹 Crear SOAT
  create(data: HistorialSoat): Observable<HistorialSoat> {
    return this.http.post<HistorialSoat>(this.apiUrl, data, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al crear SOAT:', error);
        return throwError(() => new Error('Error al crear SOAT'));
      })
    );
  }

  // 🔹 Actualizar SOAT
  update(id: number, data: HistorialSoat): Observable<HistorialSoat> {
    return this.http.put<HistorialSoat>(`${this.apiUrl}/${id}`, data, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al actualizar SOAT:', error);
        return throwError(() => new Error('Error al actualizar SOAT'));
      })
    );
  }

  // 🔹 Eliminar SOAT
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, {
      headers: this.getAuthHeaders(),
      withCredentials: true
    }).pipe(
      catchError((error) => {
        console.error('❌ Error al eliminar SOAT:', error);
        return throwError(() => new Error('Error al eliminar SOAT'));
      })
    );
  }

  // 🔹 Inactivar SOAT
inactivarSoat(id_soat: number): Observable<{ message: string }> {
  return this.http.put<{ message: string }>(`${this.apiUrl}/estado/${id_soat}`, {}, {
    headers: this.getAuthHeaders(),
    withCredentials: true
  }).pipe(
    catchError((error) => {
      console.error('❌ Error al inactivar SOAT:', error);
      return throwError(() => new Error('Error al inactivar SOAT'));
    })
  );
}

}